export interface QueryResponse {
  regions: string[];
  include_algedonic_pulse: boolean;
  telemetry_keys: string[];
  answer: string;
  correlation_id?: string;
}

export interface DaemonHealth {
  name: string;
  port: number;
  healthy: boolean;
  last_tick_age_ms: number | null;
  detail?: Record<string, unknown>;
}

export interface SnapshotResponse {
  generated_at: string;
  daemons: DaemonHealth[];
  variety: Record<string, unknown> | null;
  trust: Record<string, unknown> | null;
  mode: Record<string, unknown> | null;
  recent_algedonic: Array<Record<string, unknown>>;
}

export async function postQuery(text: string): Promise<QueryResponse> {
  const res = await fetch('/api/query', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text }),
  });
  if (!res.ok) throw new Error(`/query ${res.status}`);
  return res.json();
}

export async function getSnapshot(): Promise<SnapshotResponse> {
  const res = await fetch('/api/snapshot');
  if (!res.ok) throw new Error(`/snapshot ${res.status}`);
  return res.json();
}
